import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { get } from "api/apiCaller";
import Autocomplete from "components/Autocomplete";
import { SERVICES, SERVICES_OPTIONS, TRANSFER_UNITS } from "constant/ticket";
import { LIST_MISSION_TYPES } from "constant/ticket";
import { FieldArray, FormikProvider } from "formik";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import moment from "moment";
import mainClasses from "pages/agent-chat-ticket/AgentChatTicket.module.css";
import { RequiredField } from "pages/agent-chat-ticket/ticket";
import PackageInfo from "pages/agent-chat-ticket/ticket/PackageInfo";
import { useState } from "react";

const TicketDetail = ({
  formTicket,
  listTicketTypes,
  isTicketType,
  getTicketTypes,
  isCanEdit,
  readOnly, // chỉ view thông tin
}) => {
  const [productOptions, setProductOptions] = useState([]);
  const [openDialogPackage, setOpenDialogPackage] = useState(false);
  const [packageInfo, setPackageInfo] = useState();
  const [packageCode, setPackageCode] = useState("");
  const [isLoadingPackage, setIsLoadingPackage] = useState(false);
  const [subOrgs, setSubOrgs] = useState([]);

  const handleSearchPackage = (pakageCodeSearchValue) => {
    setPackageInfo(null);
    setPackageCode(pakageCodeSearchValue);
    setOpenDialogPackage(true);

    if (pakageCodeSearchValue) {
      setIsLoadingPackage(true);
      get(
        `/mini-crm/vnpost-crm-gateway/get-package?packageId=${pakageCodeSearchValue}`
      )
        .then((res) => {
          if (res.data?.dinhvi) res.data.dinhvi.reverse();
          setPackageInfo(res.data);
          setIsLoadingPackage(false);
        })
        .catch((err) => {
          setIsLoadingPackage(false);
        });
    }
  };

  return (
    <div>
      <form onSubmit={formTicket.handleSubmit}>
        <Grid container>
          <Grid item xs={12} style={{ display: "flex" }}>
            <div className={`${mainClasses.label} ${mainClasses.labelPackage}`}>
              Mã tin thu gom / Mã vận đơn:{" "}
              {!isTicketType("tư vấn dịch vụ") && <RequiredField />}
            </div>

            <div className={mainClasses.inputPackage}>
              <TextField
                variant="standard"
                fullWidth
                {...formTicket.getFieldProps("packageCode")}
                error={
                  formTicket.touched.packageCode &&
                  Boolean(formTicket.errors.packageCode)
                }
                helperText={
                  formTicket.touched.packageCode &&
                  formTicket.errors.packageCode
                }
                InputProps={{
                  ...(readOnly && { readOnly }),
                  classes: {
                    input: mainClasses.input,
                  },
                }}
              />
            </div>
            <div style={{ marginLeft: 15, textAlign: "center" }}>
              <span
                className={mainClasses.iconButton}
                onClick={() =>
                  handleSearchPackage(formTicket.values.packageCode)
                }>
                <i className="far fa-search"></i>
              </span>
              <div className="labelSmall">Định vị</div>
            </div>
          </Grid>

          <Grid
            item
            xs={6}
            style={{ paddingRight: 5 }}
            className={mainClasses.row}>
            <span className={mainClasses.label}>Dịch vụ:</span>
            <Autocomplete
              options={SERVICES_OPTIONS}
              getLabel={(item) => item?.name || ""}
              onChangeValue={(newServiceValue) => {
                if (newServiceValue?.key !== formTicket.values.service?.key) {
                  formTicket.setFieldValue("service", newServiceValue);
                  formTicket.setFieldValue("product", "");
                  setProductOptions(
                    SERVICES.find((item) => item.key === newServiceValue?.key)
                      ?.values || []
                  );
                }
              }}
              value={formTicket.values.service}
              InputProps={{
                ...(readOnly && { readOnly }),
                classes: {
                  input: mainClasses.input,
                },
              }}
              disabled={!!readOnly}
              enableResize
            />
          </Grid>
          <Grid
            item
            xs={6}
            style={{ paddingLeft: 5 }}
            className={mainClasses.row}>
            <span className={mainClasses.label}>Sản phẩm:</span>
            <Autocomplete
              margin="dense"
              options={productOptions}
              getLabel={(item) => item}
              onChangeValue={(item) =>
                formTicket.setFieldValue("product", item)
              }
              value={formTicket.values.product}
              InputProps={{
                ...(readOnly && { readOnly }),
                classes: {
                  input: mainClasses.input,
                },
              }}
              disabled={!!readOnly}
              enableResize
            />
          </Grid>
          <Grid item xs={12} className={mainClasses.row}>
            <span className={mainClasses.label}>Loại yêu cầu: </span>
            <RequiredField />
            <TextField
              variant="outlined"
              InputProps={{
                classes: {
                  input: mainClasses.input,
                },
              }}
              select
              fullWidth
              {...{
                ...formTicket.getFieldProps("type"),
                onChange: (event) => {
                  formTicket.setFieldValue("ticketDetail", "");
                  formTicket.setFieldValue("type", event.target.value);
                },
              }}
              error={formTicket.touched.type && Boolean(formTicket.errors.type)}
              helperText={formTicket.touched.type && formTicket.errors.type}
              disabled={!!readOnly}>
              {listTicketTypes?.map((item) => (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  classes={{ root: mainClasses.input }}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {!!getTicketTypes(formTicket.values.type).length && (
            <Grid item xs={12} className={mainClasses.row}>
              <span className={mainClasses.label}>Nội dung yêu cầu: </span>
              <RequiredField />
              <TextField
                variant="outlined"
                InputProps={{
                  classes: {
                    input: mainClasses.input,
                  },
                }}
                select
                fullWidth
                {...formTicket.getFieldProps("ticketDetail")}
                error={
                  formTicket.touched.ticketDetail &&
                  Boolean(formTicket.errors.ticketDetail)
                }
                helperText={
                  formTicket.touched.ticketDetail &&
                  formTicket.errors.ticketDetail
                }
                disabled={!!readOnly}>
                {getTicketTypes(formTicket.values.type).map((item) => (
                  <MenuItem
                    key={item}
                    value={item}
                    classes={{ root: mainClasses.input }}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          <Grid item xs={12} className={mainClasses.row}>
            <span className={mainClasses.label}>Chi tiết yêu cầu: </span>
            <RequiredField />
            <TextField
              variant="outlined"
              fullWidth
              multiline
              InputProps={{
                spellCheck: "false",
                classes: {
                  multiline: mainClasses.input,
                },
              }}
              rows={3}
              {...formTicket.getFieldProps("description")}
              error={
                formTicket.touched.description &&
                Boolean(formTicket.errors.description)
              }
              helperText={
                formTicket.touched.description && formTicket.errors.description
              }
              disabled={!!readOnly}
            />
          </Grid>
          {isTicketType("tư vấn dịch vụ") && (
            <>
              <Grid item xs={12} className={mainClasses.row}>
                <span className={mainClasses.label}>Đơn vị xử lý</span>
                <RequiredField />
                <Autocomplete
                  margin="dense"
                  options={TRANSFER_UNITS}
                  getLabel={(item) =>
                    item?.code ? `${item?.code} - ${item?.name}` : ""
                  }
                  onChangeValue={(item) =>
                    formTicket.setFieldValue("transferUnit", item)
                  }
                  value={formTicket.values.transferUnit}
                  InputProps={{
                    classes: {
                      input: mainClasses.input,
                    },
                  }}
                  disabled={!!readOnly}
                  enableResize
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: "flex" }}
                className={mainClasses.row}>
                <div className={mainClasses.label} style={{ marginTop: 3 }}>
                  Mặt hàng kinh doanh:{" "}
                </div>

                <div style={{ flex: 1 }}>
                  <TextField
                    variant="standard"
                    fullWidth
                    {...formTicket.getFieldProps("businessProduct")}
                    InputProps={{
                      ...(readOnly && { readOnly }),
                      classes: { input: mainClasses.input },
                    }}
                  />
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                className={mainClasses.row}
                style={{ display: "flex" }}>
                <div className={mainClasses.label} style={{ marginTop: 3 }}>
                  Sản lượng/tháng:{" "}
                </div>
                <div style={{ flex: 1 }}>
                  <TextField
                    variant="standard"
                    fullWidth
                    {...formTicket.getFieldProps("outputPerMonth")}
                    InputProps={{
                      ...(readOnly && { readOnly }),
                      type: "number",
                      classes: { input: mainClasses.input },
                    }}
                  />
                </div>
              </Grid>
            </>
          )}

          <Grid item xs={12} className={mainClasses.row}>
            <div className={mainClasses.label}>
              {readOnly ? "Tên cuộc chat" : "Đặt tên cuộc chat"}
            </div>
            <TextField
              variant="outlined"
              {...formTicket.getFieldProps("customFields.conversationName")}
              InputProps={{
                spellCheck: "false",
                classes: {
                  input: mainClasses.input,
                },
              }}
              inputProps={{
                maxLength: 50,
              }}
              disabled={!!readOnly}
              fullWidth
            />
          </Grid>

          <FormikProvider value={formTicket}>
            <FieldArray
              name="task"
              render={(arrayHelpers) => (
                <>
                  <Grid item xs={12} className={mainClasses.row}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(_event, checked) => {
                            if (checked)
                              arrayHelpers.insert(0, {
                                type: "",
                                description: "",
                                actionDate: moment()
                                  .startOf("day")
                                  .toISOString(),
                              });
                            else arrayHelpers.remove(0);
                            formTicket.setFieldValue("moreMisson", checked);
                          }}
                          value={formTicket.values.moreMisson}
                          checked={formTicket.values.moreMisson}
                          color="primary"
                          classes={{
                            root: mainClasses.checkBox,
                          }}
                          disabled={!!readOnly}
                        />
                      }
                      classes={{
                        root: mainClasses.formControlLabelRoot,
                        label: mainClasses.label,
                      }}
                      label="Thêm nhiệm vụ"
                    />
                  </Grid>
                  {formTicket.values.task.map((_, index) => (
                    <Grid container key={index}>
                      <Grid item xs={6} className={mainClasses.row}>
                        <div className={mainClasses.label}>
                          Loại nhiệm vụ <RequiredField />
                        </div>
                        <TextField
                          select
                          variant="outlined"
                          {...formTicket.getFieldProps(`task.${index}.type`)}
                          fullWidth
                          InputProps={{
                            classes: {
                              input: mainClasses.input,
                            },
                          }}
                          error={
                            formTicket.touched.task?.[index]?.type &&
                            Boolean(formTicket.errors.task?.[index]?.type)
                          }
                          helperText={
                            formTicket.touched.task?.[index]?.type &&
                            formTicket.errors.task?.[index]?.type
                          }
                          style={{ paddingRight: 10 }}
                          disabled={!!readOnly}>
                          {LIST_MISSION_TYPES?.map((missionType) => (
                            <MenuItem
                              key={missionType.id}
                              value={missionType.value}
                              classes={{
                                root: mainClasses.input,
                              }}>
                              {missionType.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={6} className={mainClasses.row}>
                        <div className={mainClasses.label}>
                          Thời gian thực hiện <RequiredField />
                        </div>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <InlineDatePicker
                            name="date"
                            variant="outlined"
                            format="dd-MM-yyyy"
                            {...formTicket.getFieldProps(
                              `task.${index}.actionDate`
                            )}
                            value={
                              formTicket.values.task?.[index]?.actionDate
                                ? new Date(
                                    formTicket.values.task?.[index]?.actionDate
                                  )
                                : null
                            }
                            onChange={(date) => {
                              formTicket.setFieldValue(
                                `task.${index}.actionDate`,
                                moment(date).startOf("day").toISOString()
                              );
                            }}
                            error={
                              formTicket.touched.task?.[index]?.actionDate &&
                              Boolean(
                                formTicket.errors.task?.[index]?.actionDate
                              )
                            }
                            helperText={
                              formTicket.touched.task?.[index]?.actionDate &&
                              formTicket.errors.task?.[index]?.actionDate
                            }
                            InputProps={{
                              classes: {
                                input: mainClasses.input,
                              },
                              endAdornment: (
                                <InputAdornment position="end">
                                  <i
                                    className="far fa-calendar-alt"
                                    style={{
                                      color: "#757575",
                                      cursor: "pointer",
                                    }}></i>
                                </InputAdornment>
                              ),
                            }}
                            disabled={!!readOnly}
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>

                      <Grid item xs={12} className={mainClasses.row}>
                        <span className={mainClasses.label}>
                          Chi tiết nhiệm vụ <RequiredField />
                        </span>

                        <TextField
                          variant="outlined"
                          fullWidth
                          multiline
                          InputProps={{
                            spellCheck: "false",
                            classes: {
                              root: mainClasses.input,
                              multiline: mainClasses.label,
                            },
                          }}
                          rows={3}
                          {...formTicket.getFieldProps(
                            `task.${index}.description`
                          )}
                          error={
                            formTicket.touched.task?.[index]?.description &&
                            Boolean(
                              formTicket.errors.task?.[index]?.description
                            )
                          }
                          helperText={
                            formTicket.touched.task?.[index]?.description &&
                            formTicket.errors.task?.[index]?.description
                          }
                          disabled={!!readOnly}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </>
              )}
            />
          </FormikProvider>

          {!readOnly && (
            <Grid item xs={12} style={{ display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  margin: "10px 0px 10px 0px",
                  flex: 1,
                }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={
                    formTicket.isSubmitting || !formTicket.isValid || isCanEdit
                  }
                  className={mainClasses.button}
                  type="submit">
                  Tạo ticket
                  {formTicket.isSubmitting && (
                    <CircularProgress
                      style={{
                        width: 18,
                        height: 18,
                        marginLeft: 5,
                        color: "white",
                      }}
                    />
                  )}
                </Button>
              </div>
            </Grid>
          )}
        </Grid>
      </form>

      <PackageInfo
        packageInfo={packageInfo}
        open={openDialogPackage}
        onClose={() => setOpenDialogPackage(false)}
        loading={isLoadingPackage}
        packageCode={packageCode}
      />
    </div>
  );
};

export default TicketDetail;
